export default __webpack_public_path__ + "static/font-466b1cb3cba3f2a37894336e51fd5e65.woff2";